import React from 'react';

export default function SectionHeading({ eyebrow, title, lead, align = 'left', dark = false, className = '' }) {
  const center = align === 'center';
  return (
    <div className={`${center ? 'text-center mx-auto' : ''} max-w-3xl ${className}`}>
      {eyebrow && <div className={`eyebrow ${dark ? 'text-signal' : 'text-royal'}`}>{eyebrow}</div>}
      <h2 className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] ${dark ? 'text-white' : 'text-navy'}`}>
        {title}
      </h2>
      {lead && <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? 'text-slate-300' : 'text-slate-600'}`}>{lead}</p>}
    </div>
  );
}
